// public routes
export const publicPaths = [
    // {
    //     path: '/api/metrics',
    //     method: ['POST'],
    // },
    // {
    //     path: '/api/naukriJob',
    //     method: ['POST'],
    // },
    {
        path: '/',
        method: ['GET'],
    },
    {
        path: '/api/calendar',
        method: ['POST'],
    },
    {
        path: '/api/webhooks/graph',
        method: '*',
    },
    {
        path: '/api/webhooks/graph/transcript',
        method: '*',
    },
    {
        path: '/api/webhooks/twilio-whatsapp',
        method: '*',
    },
    {
        path: '/api/webhooks/twilio/voice',
        method: ['POST'],
    },
    {
        path: '/api/webhooks/plivo/voice',
        method: ['POST'],
    },
    {
        path: '/api/webhooks/plivo/recording',
        method: ['POST'],
    },
    {
        path: '/api/webhooks/twilio/recording',
        method: ['POST'],
    },
    {
        path: '/api/webhooks/plivo-whatsapp',
        method: ['POST'],
    },
    {
        path: '/api/webhooks/stripe',
        method: '*',
    },
    {
        path: '/api/onboarding/signup',
        method: ['POST'],
    },
    {
        path: '/api/onboarding/complete-signup',
        method: ['POST'],
    },
    {
        path: '/api/onboarding/plans',
        method: ['GET'],
    },
    {
        path: '/onboarding',
        method: ['GET'],
    },
    {
        path: '/onboarding/[...path]',
        method: ['GET'],
    },
    {
        path: '/auth/signup',
        method: ['GET'],
    },
    {
        path: '/signup',
        method: ['GET'],
    },
    {
        path: '/signup/[...path]',
        method: ['GET'],
    },
    {
        path: '/api/calendar/availability',
        method: ['POST'],
    },
    {
        path: '/api/auth',
        method: '*',
    },
    {
        path: '/auth',
        method: '*',
    },
    {
        path: '/api/[companySlug]/public/career/jobs',
        method: ['GET'],
    },
    {
        path: '/api/[companySlug]/public/career/jobs/[id]',
        method: ['GET'],
    },
    {
        path: '/api/[companySlug]/public/career/jobs/[id]/upload-url',
        method: ['GET'],
    },
    {
        path: '/api/[companySlug]/public/career/config',
        method: ['GET'],
    },
    {
        path: '/api/[companySlug]/public/career/jobs/[id]/applications',
        method: ['POST'],
    },
    {
        path: '/api/[companySlug]/public/career/talent-pool/upload-url',
        method: ['GET'],
    },
    {
        path: '/api/[companySlug]/public/career/talent-pool/applications',
        method: ['POST'],
    },
    {
        path: '/api/[companySlug]/public/career/departments',
        method: ['GET'],
    },
    {
        path: '/api/company',
        method: ['GET'],
    },
    {
        path: '/api/jobs',
        method: ['GET'],
    },
    {
        path: '/api/jobApprovers/approve',
        method: ['GET', 'PUT'],
    },
    {
        path: '/api/offers',
        method: ['GET'],
    },
    {
        path: '/api/whatsapp/[companySlug]',
        method: '*',
    },
    {
        path: '/api/whatsapp',
        method: '*',
    },
    {
        path: '/api/offers/accept',
        method: ['PUT'],
    },
    {
        path: '/api/whatsapp',
        method: ['POST', 'GET'],
    },
    {
        path: '/api/calendar/scheduling-slots',
        method: ['GET'],
    },
    {
        path: '/api/calendar/panelist-slots',
        method: ['POST'],
    },
    {
        path: '/api/calendar/panelist-slots/comments',
        method: ['POST'],
    },
    {
        path: `/api/interviews`,
        method: ['GET'],
    },
    {
        path: `/api/interviews/[id]`,
        method: ['GET', 'PUT', 'DELETE'],
    },
    {
        path: `/api/interviews/[id]/interviewRound`,
        method: ['POST', 'PUT'],
    },
    {
        path: `/api/interviews/[id]/interviewRound/[interview_round_id]`,
        method: ['GET', 'DELETE'],
    },
    {
        path: `/api/interviews/[id]/interviewRound/[interview_round_id]/generate-summary`,
        method: ['POST', 'PATCH'],
    },
    {
        path: `/api/interviews/[id]/interviewRound/[interview_round_id]/ratings`,
        method: ['POST'],
    },
    {
        path: `/api/interviews/[id]/interviewRound/[interview_round_id]/panellist`,
        method: ['DELETE'],
    },
    {
        path: `/api/interviews/screeningInterview`,
        method: ['PUT'],
    },
    {
        path: `/api/interviews/screeningInterview/remind`,
        method: ['GET'],
    },
    {
        path: `/api/interviews/screeningInterview/identity-check/[id]`,
        method: ['DELETE'],
    },
    {
        path: `/api/interviews/screeningInterview/clientToken/[id]`,
        method: ['DELETE'],
    },
    {
        path: `/api/interviews/screeningInterview/speechToken/[id]`,
        method: ['DELETE'],
    },
    {
        path: `/api/jobApplications/status`,
        method: ['PATCH'],
    },
    {
        path: `/api/candidate-notes`,
        method: ['POST', 'PUT', 'DELETE'],
    },
    {
        path: `/api/candidate-notes/[id]`,
        method: ['DELETE'],
    },
    {
        path: `/api/interviews/feedback`,
        method: '*',
    },
    {
        path: `/api/interviews/feedback/generate`,
        method: '*',
    },
    {
        path: `/api/internal/stt`,
        method: '*',
    },
    {
        path: `/api/interviews/screeningInterview/candidate`,
        method: ['GET'],
    },
    {
        path: `/api/interviews/screeningInterview/start`,
        method: ['POST', 'GET'],
    },
    {
        path: `/api/interviews/screeningInterview/proctoring`,
        method: ['POST'],
    },
    {
        path: `/api/interviews/screeningInterview/clientToken`,
        method: ['GET', 'POST'],
    },
    {
        path: `/api/interviews/screeningInterview/speechToken`,
        method: ['GET'],
    },
    {
        path: `/api/interviews/screeningInterview/transitionToStarted`,
        method: ['POST'],
    },
    {
        path: '/api/interviews/screeningInterview/tts/ensure',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screeningInterview/events',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screeningInterview/iceServers',
        method: ['GET'],
    },
    {
        path: '/api/interviews/screening-webrtc/bootstrap',
        method: ['GET'],
    },
    {
        path: '/api/interviews/screening-webrtc/session',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/session/[sessionId]/connect',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/offer',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/token',
        method: ['POST'],
    },
    {
        path: '/.well-known/screening-jwks.json',
        method: ['GET'],
    },
    {
        path: '/api/interviews/screening-webrtc/recording/init',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/recording/chunk',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/recording/part-url',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/recording/finalize',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/abandon',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/session-log/append',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/session-log/finalize',
        method: ['POST'],
    },
    {
        path: '/api/interviews/screening-webrtc/network-probe',
        method: ['GET', 'HEAD', 'PUT'],
    },
    // TODO(BulkScreening): Consider removing the public exposure once frontend is migrated to authenticated calls
    {
        path: `/api/user-data`,
        method: ['GET'],
    },
    {
        path: `/api/webhooks/daily`,
        method: ['POST'],
    },
    {
        path: '/api/webhooks/azure-email',
        method: '*',
    },
    {
        path: `/api/rekognition/create-session`,
        method: ['POST', 'GET'],
    },
    {
        path: `/api/rekognition/get-results/[sessionId]`,
        method: ['GET'],
    },
    {
        path: `/auth/me`,
        method: ['GET'],
    },
    {
        path: `/auth/logout`,
        method: ['GET'],
    },
    {
        path: `/auth/login`,
        method: ['GET'],
    },
    {
        path: `/auth/callback`,
        method: ['GET'],
    },
    {
        path: `/auth/profile`,
        method: ['GET'],
    },
    {
        path: `/auth/logout`,
        method: ['GET'],
    },
    {
        path: `/auth/login`,
        method: ['GET'],
    },
    {
        path: `/auth/callback`,
        method: ['GET'],
    },
    {
        path: `/api/og/default`,
        method: ['GET'],
    },
    {
        path: `/api/og/apply`,
        method: ['GET'],
    },
    {
        path: `/api/og/company`,
        method: ['GET'],
    },
    // Offer approval (public - approvers access via email link with jobOfferSlug)
    {
        path: '/api/offers/approve',
        method: ['GET', 'PUT'],
    },
    // Document upload (public - candidates access via email link)
    {
        path: '/api/offers/upload-documents/[id]',
        method: ['GET', 'POST', 'PUT'],
    },
    // Public page routes (pathname match only, no searchParams check)
    {
        path: '/[companySlug]/recruitment/approve/[id]',
        method: ['GET'],
    },
    {
        path: '/[companySlug]/recruitment/offers/approve/[id]',
        method: ['GET'],
    },
    {
        path: '/api/auth/logout-callback',
        method: ['GET'],
    },
    {
        path: '/docs',
        method: ['GET'],
    },
    {
        path: '/docs/swagger',
        method: ['GET'],
    },
    {
        path: `/api/jd/[id]`,
        method: ['GET'],
    },
    // Candidate sharing public API routes
    {
        path: `/api/candidate-sharing/[sharingSlug]`,
        method: ['GET'],
    },
    {
        path: `/api/candidate-sharing/[sharingSlug]/feedback`,
        method: ['PUT'],
    },
    {
        path: '/api/interviews/screening-webrtc/output',
        method: ['GET'],
    },
    // Human interview feedback transcript and summary
    {
        path: '/api/interviews/feedback/transcript',
        method: ['GET'],
    },
]

/**
 * Public page routes under /companySlug/ that are not protected. Matches through regex.
 * These routes are not protected and can be accessed by anyone.
 */
export const PUBLIC_PAGE_ROUTES = [
    `^/(.*?)/career$`, // /companySlug/career
    `^/(.*?)/career/.*$`, // career pages
    `^/(.*?)/recruitment/candidate/new/(.*?)`, // new job application page
    `^/(.*?)/recruitment/offers/upload-documents/(.*?)`, // candidate document upload page
    `^/(.*?)/interview/(.*?)`, // interview feedback page
    `^/(.*?)/recruitment/approve/(.*?)`, // recruitment approve page
    `^/(.*?)/recruitment/offers/approve/(.*?)`, // recruitment offers approve page
    `^/(.*?)/candidate-review/(.*?)`, // public candidate review page
    `^/(.*?)/recruitment/create-jd$`, // create/edit/view job description page
    `^/onboarding$`,
    `^/onboarding/.*$`,
    `^/auth/signup$`,
    `^/signup$`,
    `^/signup/.*$`,
    `^/docs$`,
    `^/docs/.*$`, // swagger page
] as const
